import SeriesQ from '@/queries/SeriesQ'
import UserQ from '@/queries/UserQ'
import composeRichText from '@/client/services/richText/composeRichText'
import { getSeriesUrl } from '@/client/services/url'
import { hasUserRole } from '@/client/services/user'

import { makeBannerDataLoader } from './helpers'

export default makeBannerDataLoader({
  name: 'referred-series',
  load(context) {
    if (!hasUserRole(context.user, 'user:approved')) {
      return null
    }

    const user = context.query.one(UserQ.where({ id: context.user.id }))
    const friendReservedSeries = user.one(UserQ.getFirstPendingFriendReservedSeries())
    const friendReservedSeriesId = friendReservedSeries(SeriesQ.id)
    const seriesUrl = getSeriesUrl(friendReservedSeriesId ?? 0)

    if (friendReservedSeriesId == null) {
      return null
    }

    return {
      slug: `referred-series-${friendReservedSeriesId}`,
      link: seriesUrl,
      content: composeRichText(ctx =>
        ctx.paragraph(
          'You were invited to join a series! ',
          ctx.linkInternal(seriesUrl, 'Check it out')
        )
      ),
    }
  },
})
